import type { ReactNode } from 'react';
import { classNames } from './class-names.js';

export type NoticeTone = 'info' | 'success' | 'warning' | 'danger';

export interface NoticeProps {
  tone: NoticeTone;
  title?: string;
  children: ReactNode;
  className?: string;
}

export function Notice({ tone, title, children, className }: NoticeProps) {
  return (
    <div className={classNames('alert', alertClass(tone), 'items-start', className)} role={roleFor(tone)}>
      <div className="min-w-0">
        <NoticeTitle title={title} />
        <div className="text-sm/relaxed">{children}</div>
      </div>
    </div>
  );
}

function NoticeTitle({ title }: { title?: string }) {
  if (!title) {
    return null;
  }

  return <p className="font-semibold mb-1">{title}</p>;
}

function alertClass(tone: NoticeTone): string {
  if (tone === 'success') {
    return 'alert-success';
  }

  if (tone === 'warning') {
    return 'alert-warning';
  }

  if (tone === 'danger') {
    return 'alert-error';
  }

  return 'alert-info';
}

function roleFor(tone: NoticeTone): 'alert' | 'status' {
  if (tone === 'danger') {
    return 'alert';
  }

  return 'status';
}
